import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { USER, COMPANY_ADMIN } from 'config/permissions/roles';
import adverseEventService from './adverse-event.service';
import adverseEventComponent from './adverse-event.component';

import aeInformation from './information/information.module';
import animalHistory from './animal-history/animal-history.module';
import animalInformation from './animal-information/animal-information.module';
import caseReference from './case-reference/case-reference.module';
import closure from './closure/closure.module';
import ownerForm from './owner-form/owner-form.module';
import vetForm from './vet-form/vet-form.module';
import otherForm from './other-form/other-form.module';
import contactList from './contact-list/contact-list.module';
import riskAnalysis from './risk-analysis/risk-analysis.module';

export default
  angular.module('components.app.adverseEvent', [
    uiRouter,
    aeInformation,
    animalHistory,
    animalInformation,
    caseReference,
    closure,
    ownerForm,
    vetForm,
    otherForm,
    contactList,
    riskAnalysis
  ])
    .component('adverseEvent', adverseEventComponent)
    .service('AdverseEventService', adverseEventService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('adverseEventEdit', {
          parent: 'app',
          url: '/adverse-events/{id:int}',
          component: 'adverseEvent',
          resolve: {
            adverseEvent: (AdverseEventService, $stateParams) =>
              AdverseEventService.getAdverseEvent($stateParams.id).then(r => r.data),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            company: (CompanyService, adverseEvent) =>
              CompanyService.getCompany(adverseEvent.MemberId).then(r => r.data),
            contactTypes: AdverseEventService => AdverseEventService.getContactTypes(),
            statuses: AdverseEventService => AdverseEventService.getStatuses(),
            sexes: AdverseEventService => AdverseEventService.getAnimalSexes(),
            symptoms: AdverseEventService => AdverseEventService.getSymptoms(),
            occurrenceLikelihoods: AdverseEventService => AdverseEventService.getOccurrenceLikelihoods(),
            injuryProbabilities: AdverseEventService => AdverseEventService.getInjurityProbabilities(),
            injurySeverities: AdverseEventService => AdverseEventService.getInjuritySeverities()
          }
        })
        .state('adverseEventCreate', {
          parent: 'app',
          url: '/adverse-events/create',
          component: 'adverseEvent',
          data: {
            permissions: {
              only: [USER, COMPANY_ADMIN],
              redirectTo: 'dashboard'
            }
          },
          resolve: {
            adverseEvent: currentUser => ({
              AEId: 0,
              MemberId: currentUser.MemberId,
              Status: 'OPEN'
            }),
            statuses: AdverseEventService => AdverseEventService.getStatuses(),
            company: (CompanyService, currentUser) =>
              CompanyService.getCompany(currentUser.MemberId).then(r => r.data),
            contactTypes: AdverseEventService => AdverseEventService.getContactTypes(),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            sexes: AdverseEventService => AdverseEventService.getAnimalSexes(),
            symptoms: AdverseEventService => AdverseEventService.getSymptoms(),
            occurrenceLikelihoods: AdverseEventService => AdverseEventService.getOccurrenceLikelihoods(),
            injuryProbabilities: AdverseEventService => AdverseEventService.getInjurityProbabilities(),
            injurySeverities: AdverseEventService => AdverseEventService.getInjuritySeverities()
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.module.js